import React from "react";
import sideEffect from "../../assets/side-effects-banner.jpg";
import "./Partners.css";
import Slider from "react-slick";
function Partners() {
  return (
    <div className="Partners">
      <div className="content-container">
        <img
          className="image-partner"
          src={sideEffect}
          alt="sideEffectBanner"
        />
        <div className="text-container">
          <h1>Dawaai</h1>
          <p>
            Dawaai is Pakistan’s leading digital healthcare platform that brings
            you complete health facilities right to your doorstep. Order
            medicines online with our e-pharmacy or consult top doctors online
            in Pakistan from our App right from the comfort of your home. Dawaai
            Pakistan is the first-ever internationally certified and registered
            healthcare merchant (<span>LegitScript Certified</span>). We pride
            ourselves in providing our users with authentic medicines,{" "}
            <span> medical equipment</span> and{" "}
            <span>health supplements in Pakistan.</span>
          </p>
          <p>
            Moreover, you can opt to get to avail at-home care services such as
            home nursing services or book lab tests online. Over the years we
            have built trust by offering our users the utmost convenience to buy
            medicines. Get your prescriptions online and get monthly refill
            facilities with Dawaai Asaan orders. You can also get information
            about your medicines and learn its uses with our official medical
            content that will help you make better health choices.
          </p>
          <p>
            You can order online medicines, health products, lab test services,
            <span>online doctor consultations</span> from anywhere in Pakistan
            with ease (Karachi, Islamabad, Lahore, Rawalpindi & more) by using
            our <span>fast medicine delivery service</span> . In Karachi, you
            can get your selected medicines within 60 minutes of your order
            confirmation with dShops. Our mobile application is available on iOS
            and android.
          </p>
          <h5>ONLINE PHARMACY</h5>
          <p>
            Dawaai is an online pharmacy that sells genuine medicines at a
            discounted rate. We offer the lowest medicine price in Pakistan
            while offering several bank discounts and promo codes with Dawaai
            discounts. The process works by uploading a prescription that our
            pharmacists will verify, and create an order for you. We offer
            medicines from reputable{" "}
            <span>brands , Pfizer, GSK, Getz Pharma,</span> and more.
          </p>
          <h5>DOCTOR CONSULTATION</h5>
          <p>
            Dawaai’s Online Doctor consultation service is safe and easy. We
            offer free live chat with doctors and paid video consultations with
            doctors through easy online appointments. We have a
            multi-disciplinary team of highly qualified doctors from leading
            General Physicians, Gynaecologists, Chest Specialists,
            Dermatologists, Nutritionists to Cardiologists in Pakistan, etc that
            prioritize patient confidentiality.
          </p>
          <h5>LAB TESTS & CHECK-UPS</h5>
          <p>
            Book lab tests online at discounted rates anywhere in Pakistan on
            the Dawaai website and app. Get your urgent health check-ups and
            popular health tests such as COVID-19 IgG Antibody test, Blood
            tests, HbA1c test and more done right from your home. We provide
            online patient reports and lab packages from Chughtai Labs, Essa Lab
            and Pro-Lab.
          </p>
          <h5>HEALTH PACKAGES & PROGRAMS</h5>
          <p>
            Do you struggle to meet your health goals and maintain a healthy
            lifestyle? Worry not, Dawaai has introduced various health packages
            and programs with which you can stick to a healthier routine and
            lifestyle along with earning medicine coverages, free doctor
            consultation vouchers, and rewards. Dawaai offers Diabetes Care
            Program and Obesity Care Program that you can subscribe to at
            nominal rates.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Partners;
